
































































import { Vue, Component, Prop } from "vue-property-decorator";
import { Property } from "../properties/types";
import { propertiesStore } from "@/properties/store";

@Component({
  components: {}
})
export default class PropertyView extends Vue {
  @Prop() property!: Property;
  @Prop() propertyID!: string;
  @Prop(String) private mother!: string;

  propertyKeys = [
    "Minimum Investment",
    "Maximum Investment",
    "Equity Multiple",
    "Est. Net Rental yield",
    "20yrs Historical Growth",
    "Latest valuation",
    "Investors",
    "Latest available price",
    "Below valuation"
  ];

  propertyDetail = {};

  propertyUnits = ["$", "", "%", "%", "K", "$", "K", "$", "%"];
  get propertyValues() {
    let propertiesTemp = Object.assign({}, this.propertyDetail) as Property;
    delete propertiesTemp["imageURL"];
    delete propertiesTemp["name"];
    delete propertiesTemp["address"];
    delete propertiesTemp["bedRoom"];
    delete propertiesTemp["livingRoom"];
    delete propertiesTemp["carPark"];
    delete propertiesTemp["type"];
    delete propertiesTemp["sold"];
    delete propertiesTemp["id"];
    // @ts-ignore
    delete propertiesTemp["photo"];
    return propertiesTemp;
  }

  get isFromExplore() {
    return this.mother === "Explore";
  }

  camelToSensitiveCase(text: string) {
    let result = text.replace(/([A-Z])/g, " $1");
    let finalResult = result.charAt(0).toUpperCase() + result.slice(1);
    return finalResult;
  }
  async beforeMount() {
    // if prop undefined => retrieve property from param
    if (this.property === undefined) {
      // if there is no propertiesList on state => load a property from firebase
      if (propertiesStore.state.items.length === 0) {
        this.propertyDetail = await propertiesStore.loadProperty(this.propertyID)
      } else {
        const result = propertiesStore.state.items.find(
          property => property.id === this.propertyID
        );
        this.propertyDetail = result!;
      }
    } else {
      this.propertyDetail = this.property;
    }
  }
}
